var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.submitFlag)?_c('button',{staticClass:"btn-login",attrs:{"type":"button"},on:{"click":_vm.clickEvent}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),(_vm.submitFlag)?_c('button',{staticClass:"btn-login",attrs:{"disabled":"","type":"button"}},[_vm._v(" "+_vm._s(_vm.counterLabel)+" "+_vm._s(_vm.timer)+"s ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }